import { produce } from 'immer';
import * as actions from 'store/actions';
import { SIGN_OUT } from 'store/auth/actions';
import { ErrorState } from 'store/error/types';
import { createReducer } from 'typesafe-actions';

const initialState: ErrorState = {
  errors: [],
  hasNetworkError: false,
  isNotAuthenticated: false,
};

export const errorReducer = createReducer(initialState)
  .handleAction(actions.doAuthShowAuthModal, (state, action) => ({
    ...state,
    onClear: action.payload.actionAfterAuth,
  }))
  .handleAction(actions.doAuthHideAuthModal, (state) => ({
    ...state,
    onClear: undefined,
  }))
  .handleAction(actions.SET_IS_UNAUTHORIZED, (state) => ({
    ...state,
    isNotAuthenticated: true,
  }))
  .handleAction(actions.SET_LAST_ONLINE_TIME, (state) => ({
    ...state,
    isNotAuthenticated: false,
  }))
  .handleAction(actions.UPDATE_ASSET_ERROR, (state, action) => ({
    ...state,
    asset_errors: action.payload,
  }))
  .handleAction(actions.DELETE_ASSETS, (state, action) =>
    produce(state, (draft) => {
      const assetIds = action.payload.ids;
      if (state.asset_errors && assetIds.length) {
        draft.asset_errors = Object.fromEntries(
          Object.entries(state.asset_errors).filter(
            ([assetId]) => !assetIds.includes(assetId),
          ),
        );
        if (!Object.keys(draft.asset_errors).length) {
          delete draft.asset_errors;
        }
      }
      return draft;
    }),
  )
  .handleAction(actions.CLEAR_LOCAL_ASSET_CHANGES, (state, action) =>
    produce(state, (draft) => {
      const { assetId, assetKeyId, assessmentId } = action.payload;
      if (assessmentId) {
        // Delete assessment
        delete draft.asset_errors?.[assetId]?.assessments?.[assessmentId];
        // Delete assessment object if none left
        if (
          Object.keys(draft.asset_errors?.[assetId]?.assessments || {})
            .length === 0
        ) {
          delete draft.asset_errors?.[assetId]?.assessments;
        }
      } else if (assetKeyId) {
        // Delete key from asset
        delete draft.asset_errors?.[assetId]?.[assetKeyId];
      } else {
        // Delete entire asset
        delete draft.asset_errors?.[assetId];
      }
      // Delete asset from errors, if there are no remaining errors
      if (Object.keys(draft.asset_errors?.[assetId] || {}).length === 0) {
        delete draft.asset_errors?.[assetId];
      }
      // Delete asset errors if there are no remaining assets with errors
      if (Object.keys(draft.asset_errors || {}).length === 0) {
        delete draft.asset_errors;
      }
      return draft;
    }),
  )
  .handleAction(actions.UPLOAD_ERRORS.success, (state) => ({
    ...state,
    errors: [],
  }))
  .handleAction(SIGN_OUT.success, () => initialState);
